import * as React from "react";
import { CustomerNotification } from "@shared-ui/customer-notifications";
import { getBexApiContext } from "bernie-context";
import { AnalyticsStore, PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

interface TravelAdvisoryProps {
  context: ExtendedContextStore;
  analytics?: AnalyticsStore;
  page?: PageStore;
}

interface Identity {
  pageId: string;
  lineOfBusiness: string;
  funnelLocation: string;
}

const getIdentity = (page: PageStore): Identity => {
  const identifiers = page.pageId.split(",").map(identifier => identifier.trim());

  return {
    pageId: identifiers[0],
    lineOfBusiness: "H",
    funnelLocation: "20" // This represents Hotel-Search page
  };
};

export const TravelAdvisory: React.FC<TravelAdvisoryProps> = inject(
  "analytics",
  "page"
)((props: TravelAdvisoryProps) => {
  const { analytics, context, page } = props;
  const isTravelAdvisoryExperimentEnabled = isVariantEnabled(
    context,
    Experiment.LP_SC_Covid19_TravelAdvisory_for_LandingPages
  );

  if (!page || !page.pageId || !context || !isTravelAdvisoryExperimentEnabled) {
    return null;
  }

  const identity = getIdentity(page);

  /* istanbul ignore next */
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || "RFRR Action Event", analytics.omnitureData, null, true);
  };

  return (
    <div className="travelAdvisoryBanner uitk-cell all-cell-1-1 all-y-padding-three">
      <CustomerNotification
        inputs={{
          context: getBexApiContext(context),
          lineOfBusiness: identity.lineOfBusiness,
          funnelLocation: identity.funnelLocation,
          notificationLocation: "AFTER_HEADER"
        }}
        analyticsCallback={analyticsCallback}
      />
    </div>
  );
});
